"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JSchema_1 = require("./JSchema");
exports.JsonSchema = JSchema_1.default;
exports.fixAndMergeSchema = JSchema_1.fixAndMergeSchema;
var schemaMixin_1 = require("./schemaMixin");
exports.schemaMixin = schemaMixin_1.default;
var schemaMethods_1 = require("./schemaMethods");
exports.schemaMethods = schemaMethods_1.default;
// tslint:disable-next-line: no-var-requires
// const polyfills = require('./polyfills.ts');
var polyfills = require("./polyfills");
exports.polyfills = polyfills;
var WrappedProperty_1 = require("./WrappedProperty");
exports.WrappedPropertyCtor = WrappedProperty_1.default;
exports.wrap = WrappedProperty_1.wrap;
exports.default = JSchema_1.default;
//# sourceMappingURL=index.js.map